var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChatFlowComponent',{attrs:{"isPart":0,"intentIds":['',''],"drawerSize":1000}})
}
var staticRenderFns = []

export { render, staticRenderFns }